import React from 'react';
var PageSettingsContext = /*#__PURE__*/React.createContext({
  appName: null
});
export var PageSettingsProvider = function PageSettingsProvider(props) {
  var settings = React.useMemo(function () {
    return {
      appName: props.appName
    };
  }, [props.appName]);
  return /*#__PURE__*/React.createElement(PageSettingsContext.Provider, {
    value: settings
  }, props.children);
};
export var usePageSettings = function usePageSettings() {
  return React.useContext(PageSettingsContext);
};